import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { CalendarSlotType } from "@/Common/Models/UI/Enums";
import * as ServerOperations from "@/Common/Operations/operations.server";
import * as SubServerOperations from "@/Common/Operations/operations.server.sub";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { PredefinedSendingModel } from "../../Models/Scheduling/PredefinedSendingModel";
import { ICreateTemplateTabModel } from "../../Models/UI/Scheduling/ICreateTemplateTabModel";

class SchedulingAction extends BaseAction {
    private helper: MyleHelper;
    constructor() {
        super();
        this.helper = new MyleHelper();
    }

    public GetRuleset(rulesetId: string): void {
        let requestData =
        {
            RulesetId: rulesetId
        };
        this.Execute(ServerOperations.Server.Myle_Scheduling_GetRuleset, requestData, SubServerOperations.Scheduling.LoadRuleset);
    }

    public getTemplateLight(searchText: string): void {
        var requestData = {
            SearchText: searchText
        };

        this.Execute(ServerOperations.Server.Myle_Scheduling_LoadLightTemplate, requestData);
    }

    public getTemplateInfo(id: string): void {
        var requestData = {
            Id: id
        };

        this.Execute(ServerOperations.Server.Myle_Scheduling_GetTemplateInfo, requestData);
    }

    public deleteTemplate(id: string): void {
        var requestData = {
            Id: id
        };

        this.Execute(ServerOperations.Server.Myle_Scheduling_DeleteTemplate, requestData);
    }

    public savePredefinedTemplate(model: ICreateTemplateTabModel): void {
        var requestData = {
            Name: model.get("Name"),
            PredefinedAppointmentTemplate: [],
            RuleSetTemplate: []
        };

        let self = this;

        model.get("WorkDayList").toArray().forEach((c => {
            c.calendarSlots.map(i => {
                if (i.Type == CalendarSlotType.PredefinedAppointment) {
                    let template = new PredefinedSendingModel();

                    template.Duration = i.Model.Model.DefaultDuration;
                    template.StartDate = self.helper.CreateDateAsUTC(i.fromRaw);
                    template.ServiceDefinitionId = i.Model.Model.Id;
                    template.IsOnlineBookingAllowed = i.Model.Model.IsAvailableOnline;
                    template.TargetedClient = i.Model.Model.OnlineClienenteleCible;

                    requestData.PredefinedAppointmentTemplate.push(template);
                }
                else if (i.Type == CalendarSlotType.RuleSet) {
                    i.Model.DateStartDate = self.helper.CreateDateAsUTC(i.Model.StartDate);
                    i.Model.DateEndDate = self.helper.CreateDateAsUTC(i.Model.EndDate);
                    requestData.RuleSetTemplate.push(i.Model);
                }
            });
        }));

        this.Execute(ServerOperations.Server.Myle_Scheduling_SavePredefinedTemplate, requestData);
    }

    public updatePredefinedTemplate(model: ICreateTemplateTabModel): void {
        var requestData = {
            Name: model.get("Name"),
            TemplateId: model.get("EditionTemplateId"),
            PredefinedAppointmentTemplate: [],
            RuleSetTemplate: []
        };

        model.get("WorkDayList").toArray().map((c => {
            c.calendarSlots.map(i => {
                if (i.Type == CalendarSlotType.PredefinedAppointment) {
                    const template = new PredefinedSendingModel();

                    template.Duration = i.Model.Duration ?? i.Model.Model.DefaultDuration;
                    template.StartDate = this.helper.CreateDateAsUTC(i.fromRaw);
                    template.ServiceDefinitionId = i.Model.ServiceDefinitionId ?? i.Model.Model.Id;
                    template.IsOnlineBookingAllowed = i.Model.IsOnlineBookingAllowed ?? i.Model.Model.IsAvailableOnline;
                    template.TargetedClient = i.Model.TargetedClient ?? i.Model.Model.OnlineClienenteleCible;
                    requestData.PredefinedAppointmentTemplate.push(template);
                }
                else if (i.Type == CalendarSlotType.RuleSet) {
                    i.Model.DateStartDate = this.helper.CreateDateAsUTC(i.Model.StartDate);
                    i.Model.DateEndDate = this.helper.CreateDateAsUTC(i.Model.EndDate);
                    requestData.RuleSetTemplate.push(i.Model);
                }
            });
        }));

        this.Execute(ServerOperations.Server.Myle_Scheduling_UpdatePredefinedTemplate, requestData);
    }
}

export { SchedulingAction };
